/**
 * IMBEE-8954 (REQ-CWC-01) — the `GET /widget` → enabled-flag read.
 *
 * Lives here rather than inline in `App.tsx` so it is directly unit testable: reaching it through
 * `App` costs a full widget mount (`App.test.tsx`), which is the right price for the reveal path
 * and the wrong one for a field read. This is the whole decision REQ-CWC-01's "absent or false ⇒
 * arm nothing" and REQ-CWC-04's "unrecognised field ⇒ ignore" constrain.
 */
export const resolveLiveChatCampaignsEnabled = (data: unknown): boolean => {
  if (!data || typeof data !== 'object') return false;
  const liveChatCampaigns = (data as Record<string, unknown>).liveChatCampaigns;
  if (!liveChatCampaigns || typeof liveChatCampaigns !== 'object') return false;
  return (liveChatCampaigns as Record<string, unknown>).enabled === true;
};
